import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../App';

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#1a1a2e',
    padding: '20px',
  },
  header: {
    color: '#e94560',
    fontSize: '22px',
    fontWeight: 'bold',
    marginBottom: '4px',
    marginTop: '20px',
  },
  subtitle: {
    color: '#a0a0b0',
    fontSize: '14px',
    marginBottom: '24px',
  },
  searchCard: {
    backgroundColor: '#16213e',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
  },
  label: {
    color: '#a0a0b0',
    fontSize: '13px',
    marginBottom: '8px',
    display: 'block',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  input: {
    width: '100%',
    padding: '16px',
    backgroundColor: '#0f3460',
    border: '1px solid #0f3460',
    borderRadius: '10px',
    color: '#ffffff',
    fontSize: '18px',
    marginBottom: '12px',
    boxSizing: 'border-box',
    outline: 'none',
  },
  searchButton: {
    width: '100%',
    padding: '16px',
    backgroundColor: '#e94560',
    border: 'none',
    borderRadius: '10px',
    color: '#ffffff',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    boxSizing: 'border-box',
  },
  dealerCard: {
    backgroundColor: '#16213e',
    borderRadius: '12px',
    padding: '20px 24px',
    marginBottom: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    border: '1px solid #0f3460',
    boxSizing: 'border-box',
  },
  dealerName: {
    color: '#ffffff',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  dealerPayroll: {
    color: '#a0a0b0',
    fontSize: '13px',
    marginTop: '4px',
  },
  arrow: {
    color: '#e94560',
    fontSize: '24px',
  },
  noResults: {
    color: '#a0a0b0',
    textAlign: 'center',
    marginTop: '24px',
    fontSize: '16px',
  },
  logout: {
    color: '#a0a0b0',
    fontSize: '14px',
    marginTop: '32px',
    textAlign: 'center',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  orDivider: {
    color: '#a0a0b0',
    textAlign: 'center',
    fontSize: '13px',
    margin: '8px 0',
  },
};

function SelectDealer() {
  const [payrollSearch, setPayrollSearch] = useState('');
  const [nameSearch, setNameSearch] = useState('');
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const name = localStorage.getItem('name');

  async function search() {
    if (!payrollSearch.trim() && !nameSearch.trim()) return;
    setLoading(true);
    setError('');
    setSearched(true);
    try {
      const params = new URLSearchParams();
      if (payrollSearch.trim()) params.append('payroll', payrollSearch.trim());
      if (nameSearch.trim()) params.append('name', nameSearch.trim());
      const res = await fetch(`${API}/dealers/search?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (Array.isArray(data)) setResults(data);
      else setError('Search failed');
    } catch (e) {
      setError('Could not connect to server');
    }
    setLoading(false);
  }

  function handleKeyPress(e) {
    if (e.key === 'Enter') search();
  }

  function selectDealer(dealer) {
    localStorage.setItem('dealer', JSON.stringify(dealer));
    navigate('/start-session');
  }

  function logout() {
    localStorage.clear();
    navigate('/login');
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>Select Dealer</div>
      <div style={styles.subtitle}>Welcome, {name}</div>

      <div style={styles.searchCard}>
        <label style={styles.label}>Payroll Number</label>
        <input
          style={styles.input}
          type="text"
          value={payrollSearch}
          onChange={e => setPayrollSearch(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="e.g. EMP001"
          autoCapitalize="none"
        />
        <div style={styles.orDivider}>— or search by name —</div>
        <label style={{ ...styles.label, marginTop: '12px' }}>Last Name</label>
        <input
          style={styles.input}
          type="text"
          value={nameSearch}
          onChange={e => setNameSearch(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="e.g. Smith"
        />
        <button style={styles.searchButton} onClick={search}>
          {loading ? 'Searching...' : 'Find Dealer'}
        </button>
      </div>

      {error && <div style={{ color: '#e94560', marginBottom: 16 }}>{error}</div>}

      {searched && results.length === 0 && !loading && (
        <div style={styles.noResults}>No dealers found. Try a different search.</div>
      )}

      {results.map(dealer => (
        <div
          key={dealer.id}
          style={styles.dealerCard}
          onClick={() => selectDealer(dealer)}
        >
          <div>
            <div style={styles.dealerName}>
              {dealer.first_name} {dealer.last_name}
            </div>
            <div style={styles.dealerPayroll}>
              ID: {dealer.payroll_number}
            </div>
          </div>
          <div style={styles.arrow}>›</div>
        </div>
      ))}

      <div 
        style={{ ...styles.logout, marginBottom: '12px' }} 
        onClick={() => navigate('/change-password')}
      >
        Change Password
      </div>
      <div style={styles.logout} onClick={logout}>Sign out</div>
    </div>
  );
}

export default SelectDealer;